import {CircularProgress, Grid, Typography} from "@mui/material";
import React from "react";

export function loading() {
    return (<div className="centerv2">
        <Grid className="center" container direction={"column"} spacing={3}>
            <Grid item>
                <Typography>Caricamento in corso...</Typography>
            </Grid>
            <Grid item>
                <CircularProgress/>
            </Grid>
        </Grid>
    </div>)
}

